export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sport.vue?vue&type=template&id=6cf882bb"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/history/sport.vue?vue&type=template&id=6cf882bb
// module id = ludk
// module chunks = 0